import React from "react";
import "./index.scss";
import DialogTitle from "./dialog-title";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog/Dialog";

const ConfirmDelete = (props) => {
  const del = () => {
    props.close();
    props.func(props.id);
  };

  return (
    <Dialog
      open={props.state}
      onClose={props.close}
      aria-labelledby="form-dialog-confirm"
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle id="form-dialog-confirm-delete">Удалить?</DialogTitle>
      <DialogActions id="confirm-action-delete">
        <Button
          id="back-btn"
          onClick={props.close}
          color="primary"
          variant="contained"
        >
          Нет
        </Button>
        <Button
          onClick={() => del()}
          color="primary"
          variant="contained"
          id="delete-btn"
        >
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDelete;
